import React from 'react';
import { Link } from 'react-router-dom';
import { useSession } from '../hooks/useSession';

interface ContributeCTAProps {
  /** Optional override for the heading (defaults adapt to auth state). */
  heading?: string;
  /** Optional override for the supporting blurb. */
  blurb?: string;
  /** Optional second button shown beside the primary "add your list" action. */
  secondaryLink?: { to: string; label: string };
}

// The contribution call-to-action used at the bottom of the homepage and every
// restaurant page. Signing in / adding a list is the primary action everywhere
// (it's the flywheel: more lists → more rankings → more pages worth sharing).
const ContributeCTA: React.FC<ContributeCTAProps> = ({ heading, blurb, secondaryLink }) => {
  const { session } = useSession();

  const resolvedHeading =
    heading ?? (session ? 'Keep your rankings fresh' : 'Have your own St. Louis favorites?');
  const resolvedBlurb =
    blurb ??
    (session
      ? 'Rankum gets better with every list. Revisit your rankings, or see where the rest of St. Louis is eating.'
      : 'Rankum gets better with every list. Skip the critics and the Google Maps rabbit hole: rank the five spots you’d send a friend to, and help other people find their next favorite.');

  return (
    <div className="container mx-auto px-6 pb-20">
      <div className="max-w-4xl mx-auto">
        <div className="card p-8 md:p-10 text-center bg-amber/5 border-amber/20">
          <h2 className="font-display text-2xl md:text-3xl text-charcoal mb-3">
            {resolvedHeading}
          </h2>
          <p className="text-charcoal-light max-w-xl mx-auto mb-6">{resolvedBlurb}</p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            {session ? (
              <Link to="/my-list" className="btn-primary">
                Edit your rankings
              </Link>
            ) : (
              <Link to="/sign-up" className="btn-primary">
                Rank your top five
              </Link>
            )}
            {secondaryLink && (
              <Link to={secondaryLink.to} className="btn-secondary">
                {secondaryLink.label}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContributeCTA;
